import React from 'react';
import { pick } from 'ramda';
import { usePortletTranslations } from 'js/components/system/Portlet';
import Tabs, { Tab } from '../../common/Tabs';
import style from './index.scss';

export const TabTitle = ({ titleKey }) => {
    const t = usePortletTranslations();
    return (
        <div className={style.title}>
            <span className={style.titleText}>{t(titleKey)}</span>
        </div>
    );
};

export default ({ tabs, onChange, activeTab }) => {
    const tabsClassNames = pick(['tab', 'active'], style);
    return (
        <Tabs
            onChange={onChange}
            className={style.tabs}
            classNames={tabsClassNames}
            activeTab={activeTab}>
            {tabs.map(({ titleKey, name }) => (
                <Tab key={name} value={name}>
                    <TabTitle titleKey={titleKey} />
                </Tab>
            ))}
        </Tabs>
    );
};
